(function () {

    "use strict";

    function customMissingTranslationHandler() {
        return function (translationId, langKey) {
            return "##" + translationId + "[" + langKey + "]" + "##";
        };
    }

    //customMissinTranslationHandler.$inject = [];

    angular.module("sphforms.translate")
        .factory("translate.customMissingTranslationHandler", customMissingTranslationHandler);

})();